// Translations
import accessKeyManager from 'components/model/access-key-manager/translations/ar'
import copyButton from 'components/interface/copy-button/translations/ar'
import feedback from 'components/utility/feedback/translations/ar'
import loadingError from 'components/utility/loading-error/translations/ar'
import pagination from 'components/interface/pagination/translations/ar'
import phoneNumberVerifier from 'components/model/phone-number-verifier/translations/ar'
import providerButton from 'components/external/provider-button/translations/ar'

// Translation: Arabic > Components
const components = Object.freeze({
	external: { providerButton },
	interface: { copyButton, pagination },
	model: { accessKeyManager, phoneNumberVerifier },
	utility: { feedback, loadingError }
})

// Export
export default components
